import { render, staticRenderFns } from "./LS3DFDownload.vue?vue&type=template&id=13a05cbe&scoped=true&"
import script from "./LS3DFDownload.vue?vue&type=script&lang=js&"
export * from "./LS3DFDownload.vue?vue&type=script&lang=js&"
import style0 from "./LS3DFDownload.vue?vue&type=style&index=0&id=13a05cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a05cbe",
  null
  
)

export default component.exports